import React     from 'react';
import PropTypes from 'prop-types';

import * as S                from './info-quicken.module.scss';
import { SubActionRow }      from '../sub-action-row';
import { InfoBm }            from '../info-bm/info-bm';
import { InfoQob }           from '../info-qob/info-qob';

import { Expiry }             from '../../../common/product/expiry';
import { Price }              from '../../../common/product/price';
import { ProductName }        from '../../../common/product/prod-name';
import { TagLine }            from '../../../common/product/tag-line';
import { RemainingTime }      from '../../../common/product/remaining-time';
import { useGlobalCtx }       from '../../../../context/ctx-hook';
import { isInBetween }        from '../../../../helpers/time-helpers';
import * as ProductSelectors  from '../../../../context/selectors/product-selectors';
import * as UserSelectors     from '../../../../context/selectors/user-selectors';
import { getBillManagerType } from '../../../../context/selectors/bill-selectors';
import { getQknPriceWarn }    from '../../../../helpers/skunotices-helpers';
// import { SingleProductRow }   from '../../../pages/subscriptions/unified-sub-tile/product-single-row';
import { getProductLogo } from '../../../../context/selectors/product-selectors';


const InfoQuicken = ({ product, onClose, downgradeView=false}) => {
  const {state} = useGlobalCtx();

  const SUB          = ProductSelectors.getSubscription(state, product);
  const TIER_NOTICES = getQknPriceWarn(SUB.tierUriName, SUB.expireOn, state.country);
  let PRICE          = '';
  const HAS_QOB      = ProductSelectors.getSubscription(state, 'quicken-online-backup');
  const BM_TYPE      = getBillManagerType(state);
  // const HAS_BM       = getBMPlan(state);

  if(state.country === 'us') {
    PRICE = (TIER_NOTICES?.HAS_PRICE_UPDATE)
      ? TIER_NOTICES.PRICE
      : ProductSelectors.getPriceBySku(state, SUB.renewalSku);
  }

  if(state.country === 'ca') {
    PRICE = (TIER_NOTICES?.HAS_PRICE_UPDATE)
      ? TIER_NOTICES.PRICE
      : ProductSelectors.getPriceBySku(state, SUB.renewalSku);
  }

  // const NAME         = ProductSelectors.getProductName(state, product);
  const HAS_PAYMENT  = UserSelectors.getProductsPaymentMethod(product, state);
  // const HISTORY_LIST = UserSelectors.getUserSubHistory(state, product);

  // const IS_CANCELLED = React.useMemo(
  //   () =>
  //     !SUB.active || (!SUB.autoRenew && HISTORY_LIST?.filter(({action, createdAt}) =>
  //       (action === 'DISABLE_AUTORENEW' && isInBetween(SUB.effectiveAt, SUB.expireOn, createdAt))
  //     ).length > 0),
  //   [SUB.autoRenew, SUB.effectiveAt, SUB.expireOn, HISTORY_LIST]
  // );

  return (
    <div>
      <article className={`${S.card} ${SUB.tierUriName}`}>
        <div className={S.productInfo}>
          <div className={S.leftSide}>
            <div className={S.productHeader}>
              <img alt="square product logo" src={getProductLogo(SUB)} />
              <div className={S.headerText}>
                <ProductName sub={SUB} className={S.prodName} product='quicken' />
                <TagLine uriName={SUB.tierUriName} className={S.tagLine}/>
                {!downgradeView &&
                  <SubActionRow product={product} onClose={onClose}/>
                }
              </div>
            </div>
          </div>

          <div className={S.rightSide}>
            <Price
              price={PRICE}
              renewalFrequency={SUB.renewalFrequency}
              className={S.priceRow}
            />

            <Expiry product={product} className={S.infoExpiryRow}/>
            {SUB.active && (!SUB.autoRenew || !HAS_PAYMENT) && (
              <RemainingTime className={S.remainingTime} expireOn={SUB.expireOn}/>
            )}
          </div>
        </div>

      </article>

      {HAS_QOB && !downgradeView &&
        <InfoQob product={'quicken-online-backup'} onClose={onClose} />
      }

      {BM_TYPE != 'NONE' && !downgradeView &&
        <InfoBm product={'billmanager'} onClose={onClose} />
      }
    </div>

  );
};

InfoQuicken.displayName = 'SubProductCard';
InfoQuicken.propTypes   = {
  product: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  downgradeView: PropTypes.bool
};

export { InfoQuicken };
